/* eslint-disable no-negated-condition */
import "./block-careers.scss";

const $ = jQuery.noConflict();

function filterCareer(filterCat) {
    $(`.filter__item-btn[data-${filterCat}]`).click(function onClick() {
        $(".filter__item-btn").removeClass("active");
        $(this).addClass("active");

        const filterValue = $(this).data(filterCat);

        if (filterValue !== "all") {
            const $items = $(".job").filter(function onFilter() {
                return $(this).data(filterCat) === filterValue;
            });

            $(".job").addClass("hide");
            $items.removeClass("hide");
        } else {
            $(".job").removeClass("hide");
        }
    });
}

function initBlockCareers() {
    filterCareer("location");
    filterCareer("department");

    $(".filter__btn").click(function onClick() {
        $(this).toggleClass("filter__btn--active");
        $(this).parents(".filter").find(".filter__items").slideToggle();
    });
}

$(document).ready(function onReady() {
    initBlockCareers();
});

if (window.acf) {
    window.acf.addAction("render_block_preview", initBlockCareers);
}
